<template>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card flat>
          <v-card-title class="primary lighten-1 white--text headline">{{'Settings'|translate}}</v-card-title>
          <v-card-text>
          <v-list two-line subheader>
              <v-subheader>{{'Dashboard'|translate}}</v-subheader>
              <v-list-tile avatar>
                  <v-list-tile-content>
                      <v-list-tile-title>{{'Version'|translate}}</v-list-tile-title>
                      <v-list-tile-sub-title>{{githubSha}} </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-content>
                      <v-list-tile-title>{{'Build time'|translate}}</v-list-tile-title>
                      <v-list-tile-sub-title>{{buildTime}} </v-list-tile-sub-title>
                  </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>

            <v-subheader>{{'User'|translate}}</v-subheader>
            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{'Current Logged In User'|translate}}</v-list-tile-title>
                <v-list-tile-sub-title> </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>

            <v-subheader>{{'Facility and Points'|translate}}</v-subheader>

            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{'Current Facility'|translate}}</v-list-tile-title>
                <v-list-tile-sub-title>
                    {{$store.state.pointsListStore.pointsList.facility_name}}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{'Equipment List and Points'|translate}}</v-list-tile-title>
                <v-list-tile-sub-title>
                    {{'Equipment'|translate}}: {{$store.state.pointsListStore.pointsList.equipment_names.length}} <br>
                    {{'Points'|translate}}: {{totalPoints}} {{'used'|translate}}
                    <span v-if="$store.getters.totalLicensedPoints">
                        / {{$store.getters.totalLicensedPoints}} {{'licensed'|translate}}
                    </span>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>


              <v-subheader>{{'Setting'|translate}}</v-subheader>

            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{'Sampling Frequency'|translate}}</v-list-tile-title>
                <v-list-tile-sub-title>
                    {{$store.state.pointsListStore.pointsList.sampling_freq}}
                    {{'sample'+($store.state.pointsListStore.pointsList.sampling_freq==1?'':'s')|translate}} {{'every hour'|translate}}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
            </v-card-text>
        </v-card>
      </v-flex>
        <v-flex xs12>
            <v-card flat>
                <v-card-title class="accent white--text subheading">
                    {{'Currency and Energy Pricing'|translate}}
                </v-card-title>
                <v-card-text>
                <v-text-field class="mr-4" style="width:300px;" prepend-icon="fa-search" clearable v-model="search" type="text" :label="'Keyword filter'|translate"></v-text-field>
                        <v-data-table
                                :headers="headers"
                                disable-initial-sort
                                :items="elecPrice"
                                :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                                :items-per-page="25"
                                :search="search2"
                        >
                            <template v-slot:items="props">
                                <td class="text-xs-left">{{ props.item.name }}</td>
                                <td class="text-xs-left">{{currency }} {{ props.item.price }} {{'per kWh'|translate}}</td>

                            </template>
                        </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12>
            <v-card flat>
                <v-card-title class="accent white--text subheading">
                    {{'Points List'|translate}}
                </v-card-title>
                <v-card-text>
                    <points-draggable disabled></points-draggable>

                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12>
            <v-card flat>
                <v-card-title class="accent white--text subheading">
                    {{'Current Facility'|translate}}
                </v-card-title>
                <v-card-text>
                    <facility-switch></facility-switch>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import PointsDraggable from "../components/multiplots/PointsDraggable";
  import FacilitySwitch from '../components/FacilitySwitch'
  export default {
    name: 'Settings',
    components: { FacilitySwitch,  PointsDraggable},
    data: () => ({
      search: '',
      search2: ''
    }),
    watch: {
      search(){
        this.debounce(this.syncSearches,500);
      }
    },
    methods:{
      syncSearches(){
        this.search2=this.search
      },
      debounce(callback, wait) {
        clearTimeout(this.timeout);
        this.timeout= setTimeout(() => callback(), wait);
      },
    },
    computed: {
        githubSha(){
            return process.env.VUE_APP_GIT_HASH
        },
        buildTime(){
            return process.env.VUE_APP_BUILD_TIME
        },
        headers(){return [
            {
                text: this.$options.filters.translate('Equipment'),
                align: 'left',
                sortable: true,
                value: 'name'
            },
            {
                text: this.$options.filters.translate('Energy Price'),
                align: 'left',
                sortable: true,
                value: 'name'
            },

        ]},
      totalPoints () {
        let output = 0
        for (let i in this.$store.state.pointsListStore.pointsList.sensors){
          output += this.$store.state.pointsListStore.pointsList.sensors[i].length
        }
        return output
      },
        currency(){
          return this.$store.state.pointsListStore.pointsList.currency
        },
        elecPrice(){
            let items=[]
            for (let k in this.$store.state.pointsListStore.pointsList.electricityPrice){
                items.push({
                    name:k,
                    price:this.$store.state.pointsListStore.pointsList.electricityPrice[k]
                })
            }
            return items
        }
    }
  }
</script>

<style scoped>

</style>
